export { default } from './insights'
